import { cloudImg } from '../config/images';

export const properties = [
  {
    slug: 'grand-beach-villa',
    name: 'Grand Beach Villa',
    tagline: 'Payyambalam Beach, Kannur',
    image: cloudImg('home_page_banner.jpg'),
    rating: { value: '4.8', count: '78' },
    blurb: "Guests keep saying the same thing: you can be on the sand in under a minute. Grand Beach Villa sits right across from Payyambalam Beach, with sea-view balconies in every room and a host who regularly goes out of his way to help.",
    route: '/Grandbeachvilla'
  }
];
